import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const getLastSyncDate = async (selectedEnvironment, selectedPackage) => {
  try {
    const response = await api.post(`${QUALITY_SERVICE_API_URL}/hub/test-history/last-sync`, {
      env: selectedEnvironment.toLowerCase(),
      package: selectedPackage.toLowerCase()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching last sync:', error);
    throw error;
  }
};

const useGetLastSync = (selectedEnvironment, selectedPackage) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const result = await getLastSyncDate( selectedEnvironment, selectedPackage);
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedEnvironment, selectedPackage]);

  return { data, loading, error };
};

export default useGetLastSync; 
